import { CreditScore as CanadaCreditScorePb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/credit/credit_score_pb";
import Protobuf from "@repo/protobuf/utils";

type CreditScore = {
  score: number;
  generatedAt: Date;
};

export default CreditScore;

export namespace CreditScoreCanada {
  export const normalize = <T extends CanadaCreditScorePb | undefined>(
    proto: T
  ): CreditScore | Extract<T, undefined> =>
    proto && {
      score: proto.score,
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedAt!),
    };
}
